import React, { useEffect, useMemo } from "react";
import * as M from "./style";
import moment from "moment";
import userImg from "../../Assets/Images/user-profile-img.png";
import { useSelector } from "react-redux";
import { RootState } from "../../Redux/store";
import { Message } from "../../Config/interface.config";
import { messageScrollHandler } from "../../Utils";

interface Prop {
  activeChat: string;
}

const Messages: React.FC<Prop> = ({ activeChat }) => {
  const { messages: allMessages } = useSelector(
    (state: RootState) => state.message
  );
  const { id } = useSelector((state: RootState) => state.user);

  // Group the messages by date, but keep the full message structure (including from and to)
  const groupedMessages = useMemo(() => {
    console.log("allMessages", allMessages);
  
    return allMessages
      .filter((msg) => msg.subscriberId === activeChat && msg.createdAt)
      .reduce((acc: Record<string, Message[]>, msg) => {
        // Check if 'from' contains the image field, if not, provide a fallback
        const completeFrom = {
          ...msg.from,
          image: msg.from?.image, // Fallback to a default image or empty object
        };
  
        const date = msg.createdAt
          ? new Date(msg.createdAt).toLocaleDateString("en-GB")
          : "";
  
        if (!acc[date]) acc[date] = [];
  
        // Push the full message object into the groupedMessages object
        acc[date].push({
          ...msg, // Keep the entire message object
          from: completeFrom, // Ensure "from" always contains the image field
          to: msg.to, // Keep the "to" object intact
        });
  
        return acc;
      }, {});
  }, [allMessages, activeChat]);
  
  

  const getMessageDate = (key: string) => {
    const today = moment().format("D-MM-YYYY");
    const yesterday = moment().subtract(1, "days").format("D-MM-YYYY");
    if (key === today) return "Today";
    if (key === yesterday) return "Yesterday";
    return moment(key, "D-MM-YYYY").format("ddd, D MMM");
  };

  useEffect(() => {
    messageScrollHandler();
  }, [groupedMessages]);

  console.log(
    "Object.entries(groupedMessages)",
    Object.entries(groupedMessages)
  );

  return (
    <M.MessagesWrapper>
      {Object.entries(groupedMessages).map(([date, messages]) => (
        <M.MessageBox key={`message-date-${date}`} className="text-white">
          {messages.length > 0 && (
            <M.MessageDate>{getMessageDate(date)}</M.MessageDate>
          )}
          <M.Messages>
            {messages.map((mess, index) => (
              <M.TextMessageWrapper
                key={`${date}-message-${index}`}
                remote={(mess.from._id !== id).toString()}
              >
                {/* Log to inspect what data is being passed */}
                <>
                  {console.log(
                    "mess",
                    mess,
                    mess.from._id?.toString(),
                    id?.toString()
                  )}
                </>
                <M.ProfileImg
                  // If the sender doesn't have an image, fall back to the receiver's image or a default image
                  src={
                    mess.from.image
                      ? mess.from.image.fileURL
                      : mess.to?.image?.fileURL || userImg
                  }
                  alt="user"
                  crossOrigin="anonymous"
                />
                <M.Message remote={(mess.from._id !== id).toString()}>
                  <M.Text>{mess.text}</M.Text>
                  <M.Time remote={(mess.from._id !== id).toString()}>
                    {moment(mess.createdAt).format("HH:mm")}
                  </M.Time>
                </M.Message>
              </M.TextMessageWrapper>
            ))}
          </M.Messages>
        </M.MessageBox>
      ))}
    </M.MessagesWrapper>
  );
};

export default Messages;
